import { combineReducers } from 'redux';
import auth from './auth/authReducers';
import { wizardReducer } from './users/wizard-reducers';
import { coUserReducer } from './users/co-user-reducers';
import { workflowReducer } from './users/workflow-reducers';
import { getDashboardReducer } from './dashboard-owner/dashboard-owner';
import { AddInspectionCustomerAndVehicle } from './inspection/add-inspection-customer-vehicle';
import { SearchCustomerAndVehicleReducer } from './inspection/search-customer-vehicle-reducer';
import { PartsSeedDataReducer } from './inspection/parts-seeds-data-reducer';
import { inspectionTemplateReducer } from './inspection/template';
import {
  AddInspectionReducer,
  GetInspectionReducer,
  deleteInspectionReducer,
  getErrorCodeDetailsReducer,
} from './inspection/inspection';
import estimateRootReducer from './estimate';
import jobCardRootReducer from './job-card';
import appointmentRootReducer from './appointments';
import { invoiceReducer } from './invoice/invoice-reducer';
import { quickCheckOutReducer } from './quickCheckOut/quick-check-out-reducer';
import { CustomerReducer } from './customer/customer-reducer';
import { VehicleReducer } from './vehicle/vehicle-reducer';
import { PartsReducer } from './parts/parts-reducer';
import { SuppliesReducer } from './supplies/supplies-reducer';
import billingReducer from './billing/billing-reducer';
import weatherReducer from './weather';
import mechanicRootReducer from './mechanic';
import subscriptionReducer from './subscription/subscription-reducer';
import settingsRootReducer from './settings/settings-reducer';
import maricesRootReducer from './settings/matrix-reducer';
import reportsRootReducer from './reports';
import laborTimeGuides from './repairTimeGuides/repair-time-guides-reducer';
import { RoReducer } from './repairOrder/ro-reducer';
import workOrderReducer from './workOrder/work-order-reducer';
import taxClassReducer from './taxClass/tax-class-reducer';
import integrationsRootReducer from './integration';
import { uploadPdfAndSendEmail } from './pdf/pdf-reducer';

import CustomerVehicleSearch from './customerVehicleSearch/customerVehicleSearch';
import customerConcerns from './customerConcerns/customerConcerns';
import { ProblemReducer } from './problems/problem-reducer';
import { laborClassReducer } from './laborClass/labor-class';
import activitylogsReducer from './activitylog/activitylogs-reducer';
import paymentReducer from './payment/payment-reducer';
import termsAndConditions from './termsAndConditions/termsAndConditions';
import { purchaseOrderReducer } from './purchaseOrder/purchaseOrder-reducer';
import cannedReducer from './listing/canned-job';
import estimatorReducer from './estimator';
import campaignerReducer from './campaigner/campaigner-reducer';
import customerCommunication from './customerCommunication';
import communicationReducer from './communication/communication-reducer';
import vendorReducer from './vendor/vendor-reducer';
import epicorReducer from './epicor/epicor-reducer';

const rootReducer = () =>
  combineReducers({
    user: auth,
    activitylogs: activitylogsReducer,
    wizard: wizardReducer,
    coUser: coUserReducer,
    workflow: workflowReducer,
    getDashboard: getDashboardReducer,
    inspection: AddInspectionCustomerAndVehicle,
    deleteInspection: deleteInspectionReducer,
    obd: getErrorCodeDetailsReducer,
    searchCustomerAndVehicle: SearchCustomerAndVehicleReducer,
    partsSeedData: PartsSeedDataReducer,
    addInspection: AddInspectionReducer,
    inspectionById: GetInspectionReducer,
    estimate: estimateRootReducer,
    jobCard: jobCardRootReducer,
    appointment: appointmentRootReducer,
    invoice: invoiceReducer,
    quickCheckOut: quickCheckOutReducer,
    customer: CustomerReducer,
    vehicle: VehicleReducer,
    parts: PartsReducer,
    supplies: SuppliesReducer,
    billing: billingReducer,
    weather: weatherReducer,
    mechanic: mechanicRootReducer,
    subscription: subscriptionReducer,
    settings: settingsRootReducer,
    matrix: maricesRootReducer,
    reports: reportsRootReducer,
    laborTimeGuides: laborTimeGuides,
    ro: RoReducer,
    taxClass: taxClassReducer,
    integrations: integrationsRootReducer,
    pdf: uploadPdfAndSendEmail,
    customerConcerns,
    inspectionTemplate: inspectionTemplateReducer,
    laborClass: laborClassReducer,
    customerVehicleSearch: CustomerVehicleSearch,
    problems: ProblemReducer,
    workOrder: workOrderReducer,
    payment: paymentReducer,
    termsAndConditions,
    purchaseOrders: purchaseOrderReducer,
    cannedJobs: cannedReducer,
    estimator: estimatorReducer,
    campaigner: campaignerReducer,
    customerCommunication,
    communication: communicationReducer,
    vendor: vendorReducer,
    epicor: epicorReducer,
  });

export default rootReducer;
